import React from "react";
import { FaRegQuestionCircle } from "react-icons/fa";
/**
 Tombol hint berbentuk ikon “?”
 Cara pakai:

<HintModalButton title="Nama Pengguna">
  Nama pengguna harus unik, 6–20 karakter, dan tanpa spasi.
</HintModalButton>
 */

interface HintModalButtonProps {
  title?: string;
  //Konten hint di dalam modal 
  children: React.ReactNode;
  className?: string;
}

export const HintModalButton: React.FC<HintModalButtonProps> = ({
  title = "Hint",
  children,
  className,
}) => {
  const [open, setOpen] = React.useState(false);

  // Tutup modal saat pengguna menekan Escape
  React.useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    if (open) window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [open]);

  return (
    <>
      <span
        role="button"
        tabIndex={0}
        aria-label="Buka hint"
        onClick={() => setOpen(true)}
        className={`inline-flex items-center justify-center cursor-pointer m-0 p-0 ${
          className ?? ""
        }`}
      >
        <FaRegQuestionCircle className="h-3 w-3" />
      </span>


      {/* Modal */}
      {open && (
        <div
          className="modal modal-open bg-base-200/40 backdrop-blur-sm"
          role="dialog"
          onClick={() => setOpen(false)}
        >
          {/* // cegah modal tertutup saat konten diklik */}
          <div
            className="modal-box relative"
            onClick={(e) => e.stopPropagation()} 
          >
            <button
              className="btn btn-sm btn-circle absolute right-2 top-2"
              onClick={() => setOpen(false)}
              aria-label="Tutup"
            >
              ✕
            </button>
            <h3 className="font-bold text-lg mb-2 mt-6">{title}</h3>
            <div className="text-base leading-relaxed mb-4">{children}</div>
          </div>
        </div>
      )}
    </>
  );
};

